export default __webpack_public_path__ + "static/page-header-bg-04d61a37330b84e3ca0d7817180f6369.png";